import Notifications from "@/components/notifications";
import SearchBar from "@/components/search-bar";
import Tooltips from "@/components/tooltips";

Notifications.init();
SearchBar.init();
Tooltips.init();
